import { useEffect, useState } from "react";
import { Check, LayoutDashboard, ArrowRight, X } from "lucide-react";

const MEI_MASTER_URL = "https://go.hotmart.com/R107350370O";

const FEATURES = [
  "Controle de faturamento",
  "Limite anual do MEI",
  "DAS, notas e despesas",
  "Dashboard + checklist mensal",
];

export function MeiMasterPopup() {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const timer = window.setTimeout(() => setOpen(true), 5000);
    const onKey = (e: KeyboardEvent) => {
      if (e.key === "Escape") setOpen(false);
    };
    document.addEventListener("keydown", onKey);
    return () => {
      window.clearTimeout(timer);
      document.removeEventListener("keydown", onKey);
    };
  }, []);

  if (!open) return null;

  return (
    <div
      id="meiMasterPopup"
      role="dialog"
      aria-modal="true"
      aria-label="MEI Master OS"
      onClick={(e) => {
        if (e.target === e.currentTarget) setOpen(false);
      }}
      className="fixed inset-0 z-[90] flex items-center justify-center bg-black/60 backdrop-blur-sm p-4"
    >
      <div
        className="relative w-full max-w-lg rounded-3xl border border-border bg-card p-7 sm:p-9 shadow-elevated text-center animate-[meiPopupOpen_.35s_ease-out]"
        style={{ animationName: "meiPopupOpen" }}
      >
        <style>{`@keyframes meiPopupOpen{0%{opacity:0;transform:translateY(25px) scale(.94)}100%{opacity:1;transform:translateY(0) scale(1)}}`}</style>

        <button
          type="button"
          onClick={() => setOpen(false)}
          aria-label="Fechar"
          className="absolute top-3 right-3 flex h-8 w-8 items-center justify-center rounded-full bg-muted text-muted-foreground hover:bg-accent hover:text-accent-foreground transition"
        >
          <X className="h-4 w-4" />
        </button>

        <div className="inline-flex items-center gap-1.5 rounded-full bg-primary/10 px-3 py-1 text-[11px] font-bold uppercase tracking-widest text-primary">
          ✨ Novo para MEI
        </div>

        <div className="mx-auto mt-4 flex h-14 w-14 items-center justify-center rounded-2xl bg-primary/10 text-primary">
          <LayoutDashboard className="h-7 w-7" />
        </div>

        <h2 className="mt-4 font-display text-2xl sm:text-[28px] font-extrabold leading-tight text-balance">
          Organize seu MEI em um só lugar
        </h2>
        <p className="mt-3 text-sm sm:text-[15px] text-muted-foreground leading-relaxed">
          Controle faturamento, DAS, notas fiscais, despesas e obrigações com um sistema simples e
          organizado no Notion.
        </p>

        <ul className="mt-5 grid grid-cols-1 sm:grid-cols-2 gap-2 text-left">
          {FEATURES.map((f) => (
            <li
              key={f}
              className="flex items-center gap-2 rounded-xl bg-muted px-3 py-2.5 text-[13px] font-semibold"
            >
              <Check className="h-4 w-4 shrink-0 text-primary" />
              {f}
            </li>
          ))}
        </ul>

        <div className="mt-5">
          <div className="text-[11px] font-bold uppercase tracking-widest text-muted-foreground">
            Acesso completo
          </div>
          <div className="mt-1 font-display text-4xl font-extrabold text-foreground">
            <span className="align-top text-lg">R$</span> 67
            <span className="text-lg">,00</span>
          </div>
        </div>

        <a
          href={MEI_MASTER_URL}
          target="_blank"
          rel="sponsored noopener noreferrer"
          className="mt-5 inline-flex w-full items-center justify-center gap-2 rounded-full bg-cta px-6 py-3.5 text-base font-bold text-cta-foreground shadow-lg hover:brightness-95 transition min-h-12"
        >
          Quero conhecer o MEI Master OS <ArrowRight className="h-4 w-4" />
        </a>
        <button
          type="button"
          onClick={() => setOpen(false)}
          className="mt-3 block w-full text-sm font-medium text-muted-foreground hover:text-foreground transition"
        >
          Agora não
        </button>

        <p className="mt-4 text-[11px] text-muted-foreground leading-snug">
          Ferramenta de organização para MEI. Não substitui orientação contábil profissional.
        </p>
      </div>
    </div>
  );
}
